import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import {
  currentVoteStatus,
  getAllData,
  getHeaderHeight,
  getHostIndex,
  getHotList, getTempCommentList,
  goNewPage,
  submitApi,
} from '@src/mobile/request';
import axios from 'axios';
import { QQShare } from '@ifeng-fe/three_terminal/es/mobile/qqShare/dynamic';
const listData1 = ['yinhang', 'quanshang', 'canyin', 'dianshang', 'yimei', 'jiazhuang', 'dianqi', 'chuxinglvyou', 'dichan', 'fangchanzhongjie', 'qiche', 'xinnengyuanqiche', 'baoxian'];
const listData = ['银行', '券商', '餐饮', '电商', '医美', '家装', '电器', '出行旅游', '地产', '房产中介', '汽车', '新能源汽车', '保险'];
const shadow = 'https://x0.ifengimg.com/ucms/2022_08/C8E968B3ECD4624991D795D943FE40ADED5D6151_size2_w346_h18.png';
const qqShareCofig = {
  title: '315凤凰网财经企业打分台',
  img:
      'https://x0.ifengimg.com/ucms/2022_11/547093CD34E62525A492BE1DADDB0195B9E03E16_size131_w600_h600.jpg',
  desc: '给服务过您的企业打个分吧！13大消费领域，等你来投！',
  cb: () => {
    console.log('分享成功');
  },
};
const Layout = () => {
  const [voteHot, setVoteHot] = useState({});
  const [commentArray, setComment] = useState([]);
  const [text, setText] = useState('');
  const [showModel, setShowModel] = useState(false);
  const [modeText, setModeText] = useState('');
  const getCommentData = async () => {
    const { comments = [] } = await getHotList('shouye');

    setComment(comments);
  };
  const getData = async (code) => {
     // const offUrl = `http://test0.platform.ifengidc.com/platform/server/trackApi/getAccessToken?code=${code}&proid=weixinh5`;
     const offUrl = `https://user.iclient.ifeng.com/Api_User_Userbasic/weixinLogin?code=${code}&proid=weixinh5`;
    const res = await axios.get(offUrl);
    let { data } = res;
    let token = '';

    if (typeof data.data === 'object' ) {
      token = data.data.token;
      const user_info = data.data.user_info;
      const { realname_mobile } = user_info;

      window.localStorage.setItem('realname_mobile', realname_mobile);
    } else {

      data = JSON.parse(data.data);
      console.log(data);
      token = data.data.token;
    }

    console.log(token);
    window.localStorage.setItem('token', token);
    document.cookie = `sid=${token}; path=/; domain=.ifeng.com`;
    // setUserInfo({
    //   token: data.token,
    //   user_info: data.user_info,
    //
    // });
  };
  const getInfo = () => {
    // 微信拉起授权案例
    const callback = encodeURIComponent(
        `https://id.ifeng.com/sso/v1/?redirect=${encodeURIComponent(
            window.location.href
        )}`
    );

    const linkurl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx9bd3b38f9c278ab4&redirect_uri=${callback}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`;

    window.location.href = linkurl;
  };
  const getAllResult = async () => {

    const { vote = {} } = await getHostIndex();

    setVoteHot(vote);
  };

  useEffect(() => {
    try {
      getAllResult();
    } catch (e) {
      console.log(e);
    }

    if (window.grounds) {
      // 未登录拉起登录
      if (!window.grounds.userIsLogin()) {
        // 没有登录的话
        window.grounds.userLogin();

        return;
      } else {
        document.cookie = `sid=${window.grounds.getUserInfo().getToken()}`;
      }
    } else {
      const query = window.location.search;

      if (query.indexOf('code') > -1) {
        const url = window.location.href;
        const params = url.split('?')[1];
        const paramsArr = params.split('&');
        const paramsObj = {};

        paramsArr.forEach(item => {
          const itemArr = item.split('=');

          paramsObj[itemArr[0]] = itemArr[1];
        });
        // 发送code 到服务端

        console.log(paramsObj['code']);

          getData(paramsObj['code']);

      } else if (!window.localStorage.getItem('token') ) {
        getInfo();
      }
    }
    try {
      getCommentData();
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log(e);
    }

    getHeaderHeight();

  }, []);

  const goResult = async (index) => {

    const { rules } = await getAllData(listData1[index]);

    if (rules.etime) {
      const now = new Date().getTime();
      const endTime = new Date(rules.etime).getTime();

      if (now > endTime) {
        // 跳转到结果页
        // goNewPage(`http://test.news.ifeng.com/loc/315vote/result?name=${listData1[index]}`);
        goNewPage(`https://news.ifeng.com/loc/315vote/result?name=${listData1[index]}`);
      } else {
        try {
          const res = await currentVoteStatus(listData1[index]);

          res.forEach((item) => {
            if (item.questions?.length > 0) {
              // goNewPage(`http://test.news.ifeng.com/loc/315vote/result?name=${listData1[index]}`);
              goNewPage(`https://news.ifeng.com/loc/315vote/result?name=${listData1[index]}`);
              // goNewPage(`http://172.30.21.15:3000/mobile/news/loc/315vote/result?name=${listData1[index]}`);
            } else {
              // goNewPage(`http://test.news.ifeng.com/loc/315vote/list?name=${index}`);
              goNewPage(`https://news.ifeng.com/loc/315vote/list?name=${index}`);
              // goNewPage(`http://172.30.21.15:3000/mobile/news/loc/315vote/list?name=${index}`);
            }
          });
        } catch (e) {
          goNewPage(`https://news.ifeng.com/loc/315vote/result?name=${listData1[index]}`);
          console.log(e);
        }

      }
    }

    return true;
  };

  const changeText = (text) => {
    console.log(text);
    setText(text);
  };
  const submit = async() => {
    if (!window.ground) {
      // 微信端内
    }
    const res = await submitApi(text, 'shouye');
    const { code, message } = res;

    console.log(res);
    if (code === 117) {
      goNewPage('https://user.ifeng.com/allsite/loginmob');
    } else {
      setModeText(decodeURIComponent(message ? message : '评论成功'));
      setShowModel(true);
      setTimeout(() => {
        setModeText('');
        setShowModel(false);
      }, 3000);
    }
    setText('');
  };

return (
        <div >
          <div className={styles.layout_test}>
            <div className={styles.box} />
            <div className={styles.content} >
              <img className={styles.contentHeader} src={'https://x0.ifengimg.com/ucms/2022_09/8BF5F282B41A547D735B86118CFA5CF24B7F37FE_size29_w495_h99.png'} />
              {listData.map((item, index) => {
                return (<div key={index} className={styles.contentItem}>
                  <div onClick={() => { goResult(index); }}>
                    {item}
                  </div>
                  {(listData.length - 1 !== index) && <img src={shadow} className={styles.itemShadow} />}
                  {(index + 1 === Number(voteHot[1]) || index + 1 === Number(voteHot[2])) && <img
                      src={'https://x0.ifengimg.com/ucms/2022_09/DBF4CE6A5ECD9D018C81532B1BB2CC0A65D0B410_size4_w75_h51.png'}
                      className={styles.hot} />}
                </div>);
              })}
            </div>
            {/* 热门评论 */}
            <div>
              <div className={styles.comment}>
                热门评论
              </div>

              <div>
                {commentArray?.length > 0 && commentArray.map((item, index) => {
                  return <div key={index} className={styles.commentText}>{item.comment_contents}</div>;
                })}
              </div>
              <div className={styles.textareBox}>
                <textarea value={text} onChange={(e) => { changeText(e.target.value); }} placeholder=" 你有什么想说的..." className={styles.textare} />
                <div className={styles.textareImg}>
                  <img onClick={submit} style={{ width: '100%', height: '100%' }} src={'https://x0.ifengimg.com/ucms/2022_09/BFF953E190664B5E92C962D66E35B053A847C8DC_size7_w166_h62.png'} />
                </div>
              </div>

              <div />
            </div>
            <img className={styles.bottomImg} src={'https://x0.ifengimg.com/ucms/2022_09/8E45F5094496355B74FF065133ACF22A6294A7AD_size49_w750_h108.jpg'} />
          </div>
          {showModel && <div className={styles.model}>
            {modeText}
          </div>}
          <QQShare isHitBlack={true} content={qqShareCofig} />
        </div>

    );
};

export default errorBoundary(Layout);
